export default function (...args)
{
	return {
		regex: /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/(20[0-9][0-9])$|^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(.+))?$/,
		store_mask(match, ad, am, ay, by, bm, bd)
		{
			return (new Date(ay ?? by, (am ?? bm) - 1, ad ?? bd)).toISOString().substr(0, 10);
		},
		display_mask(match, ad, am, ay, by, bm, bd)
		{
			const d = new Date(ay ?? by, (am ?? bm) - 1, ad ?? bd);
			const dd = String(d.getDate()).padStart(2, '0');
			const mm = String(d.getMonth() + 1).padStart(2, '0');
			const yyyy = d.getFullYear();
			return `${dd}-${mm}-${yyyy}`;
		}
	};
}

